import { Box } from "@similarweb/ui-components/foundations";

import { LowCreditsBanner } from "../../components/LowCreditsBanner/LowCreditsBanner";
import { AI_AGENT_MAX_OPTION_VALUE, AI_AGENT_PRICE_PER_RECORD } from "../../constants";
import { useLowCreditsBanner } from "../../hooks/useLowCreditsBanner";
import { useQuotaGuard } from "../../hooks/useQuotaGuard";

export const LowQuotaBannerContainer = ({
    variant = "prominent",
    isInline = false,
}: {
    variant?: "compact" | "prominent" | "prominentCompact";
    isInline?: boolean;
}) => {
    const { isEnabled, isLoading, quota } = useQuotaGuard(AI_AGENT_PRICE_PER_RECORD);

    const { isVisible, bannerConfigs } = useLowCreditsBanner({
        totalQuota: quota?.total ?? 0,
        remainingQuota: quota?.remaining ?? 0,
        pricePerRecord: AI_AGENT_PRICE_PER_RECORD,
        minOptionValue: AI_AGENT_MAX_OPTION_VALUE,
        maxOptionValue: AI_AGENT_MAX_OPTION_VALUE,
    });

    const showBanner = isVisible && isEnabled && !isLoading;

    if (!showBanner) {
        return null;
    }

    return (
        <Box
            margin={!isInline ? "16px 0" : ""}
            width="100%"
        >
            <LowCreditsBanner
                {...bannerConfigs}
                variant={variant}
                isInline={isInline}
            />
        </Box>
    );
};
